//* Styles
import TestimonialContentSkeletonStyle from './style';

//* SVG
import { skeleton } from './svg';

const TestimonialContentSkeleton = () => {
	return <TestimonialContentSkeletonStyle>{skeleton}</TestimonialContentSkeletonStyle>;
};

export default TestimonialContentSkeleton;
